import { render, staticRenderFns } from "./comment_management.vue?vue&type=template&id=18a2d2e2&scoped=true"
import script from "./comment_management.vue?vue&type=script&lang=js"
export * from "./comment_management.vue?vue&type=script&lang=js"
import style0 from "./comment_management.vue?vue&type=style&index=0&id=18a2d2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a2d2e2",
  null
  
)

export default component.exports